import React, { useState } from 'react';
import { useAuthStore } from '../store/authStore';
import { Button } from '../components/ui/Button';
import { supabase } from '../lib/supabase';

export const TestUserPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [result, setResult] = useState<string | null>(null);
  const [isChecking, setIsChecking] = useState(false);

  const handleCheck = async () => {
    setIsChecking(true);
    setResult(null);
    
    try {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('email', email)
        .single();

      if (error) {
        throw error;
      }

      setResult(data ? `User found: ${data.username}` : 'User not found');
    } catch (error) {
      setResult('Error checking user existence');
      console.error('Error:', error);
    } finally {
      setIsChecking(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl font-bold mb-6 text-center">Check User Profile</h2>
        
        <div className="space-y-4">
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
              Email to check
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-purple-500 focus:border-purple-500"
              placeholder="Enter email"
            />
          </div>

          <Button
            onClick={handleCheck}
            isLoading={isChecking}
            fullWidth
            disabled={!email.trim()}
          >
            Check User
          </Button>

          {result && (
            <div className={`mt-4 p-3 rounded-md text-center ${
              result.includes('found:') 
                ? 'bg-green-50 text-green-700' 
                : 'bg-red-50 text-red-700'
            }`}>
              {result}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};